import {Project} from "./Project"
import {Task} from "./Task"

const PLAN = 'plan';
const PLAN_BY_TASK = 'planByTask';
const PLAN_BY_TEAM = 'planByTeam';
const MATERIAL = 'material';
const CLEARING = 'clearing';
const TOOL = 'tool';
const AVOR = 'avor';
const WARRANTY = 'warranty';
const SITE = 'site';

const TYPES = {
    [PLAN]:         { name: 'Planungsliste',        subTaskFilter: false,  groupBy: null},
    [PLAN_BY_TASK]: { name: 'Planungsliste',        subTaskFilter: false,  groupBy: 'task'},
    [PLAN_BY_TEAM]: { name: 'Planungsliste',        subTaskFilter: false,  groupBy: 'team_lead'},
    [MATERIAL]:     { name: 'Bestellliste',         subTaskFilter: true,   groupBy: 'task'},
    [CLEARING]:     { name: 'Abräumliste',          subTaskFilter: true,   groupBy: 'task'},
    [TOOL]:         { name: 'Werkzeugliste',        subTaskFilter: false,  groupBy: 'pump'},
    [AVOR]:         { name: 'Vorausmassliste',      subTaskFilter: false,  groupBy: null},
    [WARRANTY]:     { name: 'Garantiefälle',        subTaskFilter: false,  groupBy: null},
    [SITE]:         { name: 'Baustelle', subTaskFilter: false,  groupBy: null},

};

export const Report = {
    PLAN,
    PLAN_BY_TASK,
    PLAN_BY_TEAM,
    MATERIAL,
    CLEARING,
    TOOL,
    AVOR,
    WARRANTY,
    SITE,

    getName(reportType) {
        return TYPES[reportType].name;
    },

    hasSubTaskFilter(reportType) {
        return TYPES[reportType].subTaskFilter;
    },

    getGroupBy(reportType) {
        return TYPES[reportType].groupBy;
    },

    getColumns(reportType) {
        switch (reportType) {
            case PLAN:
                return Task.getReportPlanColumns();
            case PLAN_BY_TASK:
                return Task.getReportPlanTaskColumns();
            case PLAN_BY_TEAM:
                return Task.getReportPlanTeamColumns();
            case MATERIAL:
                return Task.getReportMaterialColumns();
            case CLEARING:
                return Task.getReportClearingColumns();
            case TOOL:
                return Task.getReportToolColumns();
            case AVOR:
                return Project.getReportAvorColumns();
            case WARRANTY:
                return Task.getReportWarrantyColumns();
            case SITE:
                return Task.getReportSiteColumns();
            default:
                return [];
        }
    },

    sortPlanRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by start_date
            const dateA = new Date(a.start_date);
            const dateB = new Date(b.start_date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by task order (Arbeitskategorie Order)
            if (a.taskOrder < b.taskOrder) return -1;
            if (a.taskOrder > b.taskOrder) return 1;

            // compare by sub_task value (Arbeitesvorgang)
            if (a.sub_task < b.sub_task) return -1;
            if (a.sub_task > b.sub_task) return 1;

            // all fields equal
            return 0;
        });
    },

    sortPlanTaskRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by task order (Arbeitskategorie Order)
            if (a.taskOrder < b.taskOrder) return -1;
            if (a.taskOrder > b.taskOrder) return 1;

            // compare by start_date
            const dateA = new Date(a.start_date);
            const dateB = new Date(b.start_date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by sub_task (Arbeitesvorgang)
            if (a.sub_task < b.sub_task) return -1;
            if (a.sub_task > b.sub_task) return 1;

            // all fields equal
            return 0;
        });
    },

    sortPlanTeamRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by team_lead — null-safe comparison
            const team_leadA = a.team_lead || '';
            const team_leadB = b.team_lead || '';
            if (team_leadA < team_leadB) return -1;
            if (team_leadA > team_leadB) return 1;

            // compare by start_date
            const dateA = new Date(a.start_date);
            const dateB = new Date(b.start_date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by nr
            if (a.nr < b.nr) return -1;
            if (a.nr > b.nr) return 1;

            // all fields equal
            return 0;
        });
    },

    sortMaterialRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by task order (Arbeitskategorie Order)
            if (a.taskOrder < b.taskOrder) return -1;
            if (a.taskOrder > b.taskOrder) return 1;

            // compare by start_date
            const dateA = new Date(a['start_date']);
            const dateB = new Date(b['start_date']);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by sub_task (Arbeitesvorgang)
            if (a.sub_task < b.sub_task) return -1;
            if (a.sub_task > b.sub_task) return 1;

            // all fields equal
            return 0;
        });
    },

    sortClearingRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by task order (Arbeitskategorie Order)
            if (a.taskOrder < b.taskOrder) return -1;
            if (a.taskOrder > b.taskOrder) return 1;

            // compare by foreman — null-safe comparison
            const foremanA = a.foreman || '';
            const foremanB = b.foreman || '';
            if (foremanA < foremanB) return -1;
            if (foremanA > foremanB) return 1;

            // compare by end_date
            const dateA = new Date(a['end_date']);
            const dateB = new Date(b['end_date']);
            return dateA - dateB;
        });
    },

    sortToolRows(reportRows) {
        return reportRows.sort((a, b) => {
            // compare by pump (Pumpe)
            if (a.pump < b.pump) return -1;
            if (a.pump > b.pump) return 1;

            // compare by start_date
            let dateA = new Date(a.start_date);
            let dateB = new Date(b.start_date);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by end_date
            dateA = new Date(a['end_date']);
            dateB = new Date(b['end_date']);
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            // compare by zip (PLZ)
            if (a.zip < b.zip) return -1;
            if (a.zip > b.zip) return 1;

            // all fields equal
            return 0;
        });
    },

    sortReportRows(reportType, reportRows) {
        switch (reportType) {
            case PLAN:
                return this.sortPlanRows(reportRows);
            case PLAN_BY_TASK:
                return this.sortPlanTaskRows(reportRows);
            case PLAN_BY_TEAM:
                return this.sortPlanTeamRows(reportRows);
            case MATERIAL:
                return this.sortMaterialRows(reportRows);
            case CLEARING:
                return this.sortClearingRows(reportRows);
            case TOOL:
                return this.sortToolRows(reportRows);
            default:
                // AVOR    : sort by "Planungsdatum" directly delivered from the db query
                // WARRANTY: sortByGridSortModel in the Search Component
                // SITE    : sortByGridSortModel in the Search Component
                return reportRows;
        }
    },

    subTaskKeys(reportType, code) {
        switch (reportType) {
            case MATERIAL:
                return code.getSubTaskKeysMaterialList();
            case CLEARING:
                return code.getSubTaskKeysClearingList();
            default:
                return [];
        }
    },

    subTaskFilter(reportType, code, rows) {
        const filter = this.subTaskKeys(reportType, code)
        return rows.filter(row => filter.includes(row.sub_task_code_key));
    },

    clearingFilter(rows) {
        return rows.filter(row => row.cleared !== 1);
    },

    pumpFilter(rows) {
        return rows.filter(row => row.pump_code_key !== -1).filter(row => row.pump_code_key !== null);
    },

    getReportRows(reportType, code, rows) {
        // clone view roles
        const clonedRows = [...rows];

        // filter data
        let reportRows = null;
        if (reportType === MATERIAL) {
            reportRows = this.subTaskFilter(reportType, code, clonedRows);
        } else if (reportType === CLEARING) {
            reportRows = this.clearingFilter( this.subTaskFilter(reportType, code, clonedRows) );
        } else if (reportType === TOOL) {
            reportRows = this.pumpFilter(clonedRows);
        } else {
            reportRows = clonedRows;
        }

        // sort
        return this.sortReportRows(reportType, reportRows);
    },

    /**
     * Generic sort methode used to sort the rows similar to the CxDateGrid sort order (sortModel).
     * The sortModel is delivered by the CxDataGrid onSortModelChange callback methode and consists of the field name
     * and sort asc/desc info.
     *
     * Note:
     * - This sort is independent of the sortReportRows methode (which is mainly used by the planning view).
     * - This sort may be used for search results, like the warranty- or deputy-search.
     */
    sortByGridSortModel(rows, sortModel) {
        if (!sortModel || sortModel.length === 0) return rows;
        const { field, sort } = sortModel[0];
        return [...rows].sort((a, b) => {
            const valA = a[field] ?? '';
            const valB = b[field] ?? '';
            if (valA < valB) return sort === 'asc' ? -1 : 1;
            if (valA > valB) return sort === 'asc' ? 1 : -1;
            return 0;
        });
    }

};
